var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { authentication } from "zebdsh.login.authentication";
import * as Utils from "../utils/Utils";
import { getConfig } from "../utils/config";
import * as mod_i18n from "../utils/i18n";
import { AppState } from "./AppState";
import { Breakpoint } from "./models";
export class AppModelImpl {
    constructor(custom) {
        this.initializeAuthInfo = () => {
            console.log("initializeAuthInfo: config auth", this.auth);
            if (this.auth["userinfoEndpoint"]) {
                const userinfoEndpoint = this.auth["userinfoEndpoint"];
                Utils.fetchAsync(userinfoEndpoint, null, (value) => {
                    this.authInfo = {
                        isAuthenticated: true,
                        displayName: `${value.given_name} ${value.family_name}`,
                        userName: value.email,
                        oid: value.email, // not required anymore
                    };
                    this._authSubscribers.forEach((callback) => {
                        if (callback) {
                            callback(this.authInfo);
                        }
                    });
                }, (error) => {
                    this.authInfo = {
                        isAuthenticated: false,
                        displayName: "-",
                        userName: "",
                        oid: "",
                    };
                    this._authSubscribers.forEach((callback) => {
                        if (callback) {
                            callback(this.authInfo);
                        }
                    });
                });
            }
            else {
                this.authInfo = getAuthState();
                this._authSubscribers = [];
                this._authSubscription = authentication.subscribeAuthChanged((data) => {
                    const newAuthInfo = getAuthStateFromData(data);
                    this.authInfo = newAuthInfo;
                    this._authSubscribers.forEach((callback) => {
                        if (callback) {
                            callback(newAuthInfo);
                        }
                    });
                });
            }
        };
        this.login = () => {
            var _a;
            if (this.auth["loginEndpoint"]) {
                const loginEndpoint = this.auth["loginEndpoint"];
                const client_id = (_a = this.auth["clientId"]) !== null && _a !== void 0 ? _a : "";
                const resolvedLoginEndpoint = loginEndpoint.replace("{client_id}", client_id);
                window.location.href = window.location.origin + resolvedLoginEndpoint;
            }
            else {
                authentication.doLogin();
            }
        };
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            if (this.auth["logoutEndpoint"]) {
                const logoutEndpoint = this.auth["logoutEndpoint"];
                window.location.href = window.location.origin + logoutEndpoint;
            }
            else {
                authentication.signOut();
            }
        });
        this.passwordReset = () => __awaiter(this, void 0, void 0, function* () {
            if (authentication.isAuthenticated()) {
                authentication.passwordReset();
            }
        });
        this.custom = custom != null ? custom : {};
        if (typeof this.custom !== "object") {
            throw "custom is not an object";
        }
        this.config = getConfig();
        this.pathToAppRoot = this.config["pathToAppRoot"];
        this.pathToStatic = this.config["pathToResources"];
        this.pathToAppFrameApi = this.config["pathToAppRoot"] + "frame/api/v1.0/";
        this.auth = this.config["auth"];
        this.language = mod_i18n.getDocumentLanguage();
        this.appState = new AppState();
        this.theme = this.createAppTheme();
        this._authSubscribers = [];
        document.title = this.getDocumentTitle();
        this.authInfo = {
            isAuthenticated: false,
            displayName: "-",
            userName: "",
            oid: "",
        };
        this.initializeAuthInfo();
        this.setBreakpoint(window.innerWidth);
        window.addEventListener("resize", () => {
            this.setBreakpoint(window.innerWidth);
        });
    }
    setBreakpoint(width) {
        width < 720
            ? this.appState.setBreakpoint(Breakpoint.sm)
            : this.appState.setBreakpoint(Breakpoint.lg);
    }
    subscribeToAuthChanged(callback) {
        this._authSubscribers.push(callback);
        if (callback) {
            const data = this.authInfo;
            callback(data);
        }
        const authSubscribers = this._authSubscribers;
        return {
            unsubscribe() {
                const index = authSubscribers.indexOf(callback);
                if (index !== -1) {
                    authSubscribers.splice(index, 1);
                }
            },
        };
    }
    i18n(id) {
        return mod_i18n.i18next.t(id);
    }
    i18nFromData(data, def) {
        return mod_i18n.getFromData(data, this.language, this.config.defaultLanguage, def);
    }
    createAppTheme() {
        const getPrimaryColor = () => {
            if (this.custom.theme && this.custom.theme.palette) {
                return this.custom.theme.palette.primary.main;
            }
            return "#009fe0"; //zeb default "var(--clr-secondary)"
        };
        const getFontFamily = () => {
            if (this.custom.theme && this.custom.theme.fontFamily) {
                return this.custom.theme.fontFamily;
            }
            return "BrownStd-Regular"; //"var(--default-font-family)",
        };
        const getFontFamilyBold = () => {
            if (this.custom.theme && this.custom.theme.fontFamily) {
                return this.custom.theme.fontFamily;
            }
            return "BrownStd-Bold";
        };
        const getLogoConfig = () => {
            var _a, _b, _c;
            if (this.custom.logo) {
                return {
                    path: (_a = this.custom.logo.path) !== null && _a !== void 0 ? _a : this.pathToStatic + "images/logo-zeb.svg",
                    width: (_b = this.custom.logo.width) !== null && _b !== void 0 ? _b : "5rem",
                    height: (_c = this.custom.logo.height) !== null && _c !== void 0 ? _c : "5rem",
                };
            }
            return {
                path: this.pathToStatic + "images/logo-zeb.svg",
                width: "5rem",
                height: "5rem",
            };
        };
        return {
            primaryColor: getPrimaryColor(),
            fontFamily: getFontFamily(),
            fontFamilyBold: getFontFamilyBold(),
            logoConfig: getLogoConfig(),
        };
    }
    getTitleBase() {
        let title = null;
        if (this.config.appName != null) {
            title = this.config.appName;
        }
        if (this.custom.title) {
            const customTitle = this.i18nFromData(this.custom.title, title);
            if (customTitle != null) {
                title = customTitle;
            }
        }
        return title;
    }
    getTitle() {
        let title = this.getTitleBase();
        if (title == null || title.length == 0) {
            title = "zeb digital services";
        }
        return title;
    }
    getDocumentTitle() {
        let title = this.getTitleBase();
        if (title == null || title.trim().length == 0) {
            title = "";
        }
        else {
            title = title + " | ";
        }
        return title + "zeb digital services";
    }
}
function getAuthState() {
    return getAuthStateFromData({
        isAuthenticated: authentication.isAuthenticated(),
        displayName: authentication.getDisplayName(),
        userName: authentication.getUserName(),
        oid: authentication.getOid(),
    });
}
function getAuthStateFromData(data) {
    return {
        isAuthenticated: data.isAuthenticated == true,
        displayName: data.isAuthenticated == true ? data.displayName : "-",
        userName: data.isAuthenticated == true ? data.userName : "",
        oid: data.isAuthenticated == true ? data.oid : "",
    };
}
